import { FeatureGating, IgnoreLocalizationsSchema, LocalNotificationsSchema, OnDeviceCache, PageStyles, PaywallPresentationStyle, PaywallTemplateType, PresentationCondition, SubSchema, SurveyPresentationCondition } from "@superwall-me/schema";
import { z } from "zod";
const ManifestSchema = z.object({
    resources: z.array(z.object({
        url: z.string(),
        mime_type: z.string()
    }))
});
export const Substitutions = z.object({
    substitutions: z.array(SubSchema)
});
const ProductsSchema = z.array(z.object({
    reference_name: z.string(),
    identifier: z.string()
}));
export const parsePaywall = (paywall)=>{
    const substitutions = paywall.substitutions ? Substitutions.parse(paywall.substitutions).substitutions : [];
    const pageStyles = paywall.pageStyles ? PageStyles.parse(paywall.pageStyles) : [];
    const localNotifications = paywall.localNotifications ? LocalNotificationsSchema.parse(paywall.localNotifications) : [];
    const ignoredLocalizations = paywall.ignoredLocalizations ? IgnoreLocalizationsSchema.parse(paywall.ignoredLocalizations) : [];
    const manifest = paywall.manifest ? ManifestSchema.parse(paywall.manifest) : {
        resources: []
    };
    const products = paywall.products ? ProductsSchema.parse(paywall.products) : null;
    //@ts-ignore
    return {
        ...paywall,
        ...typeof paywall.substitutions != "undefined" ? {
            substitutions
        } : {},
        ...typeof paywall.pageStyles != "undefined" ? {
            pageStyles
        } : {},
        ...typeof paywall.localNotifications != "undefined" ? {
            localNotifications
        } : {},
        ...typeof paywall.ignoredLocalizations != "undefined" ? {
            ignoredLocalizations
        } : {},
        ...typeof paywall.manifest != "undefined" ? {
            manifest
        } : {},
        ...typeof paywall.products != "undefined" ? {
            products
        } : {}
    };
};
// This is all the stuff we'll store in a paywall snapshot to
// to allow for snapshotting, then promotion
export const ParsedPaywallData = z.object({
    // Toggles, flags, etc
    templateType: z.nativeEnum(PaywallTemplateType).nullable(),
    presentationStyle: z.nativeEnum(PaywallPresentationStyle),
    backgroundColorHex: z.string(),
    darkBackgroundColorHex: z.string().nullable(),
    presentationCondition: z.nativeEnum(PresentationCondition),
    localNotifications: z.optional(LocalNotificationsSchema),
    featureGating: z.nativeEnum(FeatureGating),
    onDeviceCache: z.nativeEnum(OnDeviceCache),
    // Main table stuff
    name: z.string(),
    url: z.string(),
    manifest: ManifestSchema,
    products: ProductsSchema,
    primaryProductIdentifier: z.string().nullable(),
    secondaryProductIdentifier: z.string().nullable(),
    tertiaryProductIdentifier: z.string().nullable(),
    // Surveys
    surveys: z.optional(z.array(z.object({
        surveyId: z.number(),
        surveyPresentationCondition: z.nativeEnum(SurveyPresentationCondition)
    })))
});
export const LocalizedSubstitution = z.object({
    key: z.string(),
    value: z.string(),
    freeTrialValue: z.string().optional()
});
export const LocalizedSubstitutions = z.object({
    substitutions: z.array(LocalizedSubstitution)
});
export const parseLocalization = (paywallLocalization)=>{
    const substitutions = paywallLocalization.substitutions ? LocalizedSubstitutions.parse(paywallLocalization.substitutions).substitutions : [];
    return {
        ...paywallLocalization,
        substitutions
    };
};
